import React, { useState, useEffect } from "react";

const FillInTheBlanksInput = ({
  sentence,
  submitted,
  onSubmit,
}) => {
  const [parts, setParts] = useState([]);
  const [placeholderIndices, setPlaceholderIndices] = useState([]);
  const [userInput, setUserInput] = useState([]);

  useEffect(() => {
    if (sentence) {
      const partsArray = sentence.split(
        /(__add_blank__|<span[^>]*>.*?<\/span>)/
      );
      setParts(partsArray);

      const indicesArray = partsArray
        .map((part, index) => (part.startsWith("<span") ? index : null))
        .filter((index) => index !== null);
      setPlaceholderIndices(indicesArray);

      // Initialize userInput as an array of empty strings based on the number of placeholders
      const initialUserInput = Array(indicesArray.length).fill("");
      setUserInput(initialUserInput);
    }
  }, [sentence]);

  const handleInputChange = (event, index) => {
    const option = event.target.value;
    // Update the corresponding index in userInput with the new option
    const updatedUserInput = [...userInput];
    updatedUserInput[index] = option.trim();
    setUserInput(updatedUserInput);

    // Pass user input changes back to parent component
    onSubmit(updatedUserInput);
  };

  const getCorrectAnswer = (index) => {
    const spanPart = parts[placeholderIndices[index]];
    if (spanPart) {
      const correctAnswer = spanPart.match(/<span[^>]*>(.*?)<\/span>/);
      if (correctAnswer && correctAnswer.length > 1) {
        return correctAnswer[1].trim();
      }
    }
    return "";
  };

  useEffect(() => {
    // Clear userInput when submitted status changes to false and retake is triggered
    if (!submitted) {
      setUserInput(Array(placeholderIndices.length).fill(""));
    }
  }, [submitted, placeholderIndices.length]);

  return (
    <section className="rounded-md border border-slate-200 bg-white p-4 shadow-sm sm:p-5">
      <div className="mb-4">
        <p className="text-sm font-semibold uppercase text-purple-700">
          Transcript
        </p>
        <h2 className="mt-1 text-lg font-extrabold text-gray-900">
          Type the missing words
        </h2>
      </div>

      <form onSubmit={(e) => e.preventDefault()}>
        <div className="rounded-md bg-slate-50 p-4 text-sm leading-8 text-gray-700 ring-1 ring-slate-100 sm:text-base">
          {parts.map((part, index) => {
            if (part.startsWith("<span") && part.endsWith("</span>")) {
              const placeholderIndex = placeholderIndices.indexOf(index);
              return (
                <input
                  key={index}
                  type="text"
                  onChange={(event) =>
                    handleInputChange(event, placeholderIndex)
                  }
                  value={userInput[placeholderIndex]}
                  className={`mx-1 inline-block rounded-md border px-3 py-2 text-sm font-bold outline-none transition focus:border-purple-400 focus:ring-2 focus:ring-purple-100 ${
                    part.length > 10 ? "w-28" : "w-20"
                  } ${
                    submitted &&
                    userInput[placeholderIndex].trim() ===
                      getCorrectAnswer(placeholderIndex).trim()
                      ? "border-green-200 bg-green-50 text-green-700"
                      : submitted &&
                        userInput[placeholderIndex].trim() !==
                          getCorrectAnswer(placeholderIndex).trim()
                      ? "border-red-200 bg-red-50 text-red-700"
                      : "border-purple-200 bg-white text-purple-800"
                  }`}
                  disabled={submitted}
                />
              );
            } else if (!part.includes("__add_blank__")) {
              return <span key={index}>{part}</span>;
            } else {
              return null;
            }
          })}
        </div>
      </form>
    </section>
  );
};

export default FillInTheBlanksInput;
